import API from '../services/api';

export const getLocationReferences = async () => {
  const res = await API.get("/location-references");

  const locationReferences = res.data;

  return locationReferences
};

export const getShipsGoData = async (data) => {
  const res = await API.post("/tracking", data);

  const dataShipsGo = res.data;
  return dataShipsGo
};
